import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import AsyncStorage from '@react-native-async-storage/async-storage';
import * as Localization from 'react-native-localize';

import en from './en.json';
import ja from './ja.json';

const resources = {
    en: {
        translation: en,
    },
    ja: {
        translation: ja,
    },
};
// i18nの初期化
i18n.use(initReactI18next).init({
    resources,
    lng: Localization.getLocales()[0].languageCode, // デバイスのデフォルト言語
    fallbackLng: 'en',
    compatibilityJSON: 'v3', // 必要に応じて設定
    interpolation: {
        escapeValue: false, // ReactでのXSS対策は不要
    },
});

// 言語を保存する関数
export const setLanguage = async (lang: string): Promise<void> => {
    await AsyncStorage.setItem('userLanguage', lang);
    i18n.changeLanguage(lang);
};

// 保存された言語を取得する関数
export const getLanguage = async (): Promise<string> => {
    const lang = await AsyncStorage.getItem('userLanguage');
    return lang || Localization.getLocales()[0].languageCode;
};

export default i18n;
